import React from 'react'
import axios from 'axios'
import Uploader from './../components/uploader'

const Item = ({item, remove, update, submit, handleImageUploadComplete}) => {
	return (
		<form className="row" data-id={item.id} onChange={ (e) => {update(e.target.closest('form'))} } onSubmit={submit}>
			<div className="col_4">
				{ item.head_shot ? <img src={item.head_shot} alt={item.name} data-src={item.head_shot} /> : null }
				<Uploader
					className="head_shot_drop"
					uploadComplete={ (imageURL) => handleImageUploadComplete(imageURL, item.id) }
					label="Drop an image (or click) to update head shot"
				/>
			</div>
			<div className="col_8">
				<input
					type="text"
					defaultValue={item.name ? decodeURIComponent(item.name) : ''}
					placeholder="Name"
					className="name" />
				<input
					type="text"
					defaultValue={item.title ? decodeURIComponent(item.title) : ''}
					placeholder="Title"
					className="title" />
				<textarea
					defaultValue={item.bio ? decodeURIComponent(item.bio) : ''}
					placeholder="bio"
					className="bio"></textarea>
				<button
					type="delete"
					onClick={ () => {remove(item.id)}}>Delete {decodeURIComponent(item.name)}</button>
			</div>
		</form>
	)
}

const List = ({items, remove, update, submit, handleImageUploadComplete}) => {
	return (
		<div className="items_container">
			{items.map( item => {
				return (<Item
					item={item}
					key={item.id}
					remove={remove}
					update={update}
					submit={submit}
					handleImageUploadComplete={handleImageUploadComplete} /> )
			})}
		</div>
	)
}

class Staff extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: [],
			readyToSave: false,
			changesSaved: false,
			message: ''
		}
	}

	componentDidMount(){
		this.fetchData(this.props.id)
	}

	fetchData(id){
		axios.get('https://dhsetheatre-api.madebypeppernet.com//api-admin.php', {
			params: {
				filename: 'staff',
				preview: true,
				collection: true,
			}
		}).then( response => {
			this.setState({
				items: response.data.items
			})
		})
	}

	handleAddNewItem(){
		// Render a new form.
		const items = this.state.items

		// Generate a new id.
		const id = items.reduce( (id, item) => {
			if(item.id >= id){
				id = parseInt(item.id, 10) + 1
			}
			return id
		}, 0)

		// Add the new item to the list.
		items.push({
			id: id,
			name: '',
			title: '',
			bio: '',
			head_shot: null
		})

		// Save it to state.
		this.setState({ items })
	}

	handleImageUploadComplete(imageURL, id){
		// Need to store the imageURL to the form.
		var items = this.state.items.map( item => {
			if(item.id === id){
				item.head_shot = imageURL
			}
			return item
		})

		this.setState({
			items: items,
			readyToSave: true
		})
	}

	handleItemRemove(id){
		// Filter the list by the item selected to remove.
		// eslint-disable-next-line
		const items = this.state.items.filter( item => item.id != id )

		// Save the updated array to state.
		this.setState({
			items: items,
			readyToSave: true,
			message: ''
		})
	}

	handleItemUpdate(form){
		// Generate a new list updating the selected item.
		var items = this.state.items.map( item => {
			// eslint-disable-next-line
			if(item.id == form.getAttribute('data-id')){
				return {
					id: form.getAttribute('data-id'),
					name: encodeURIComponent(form.querySelector('.name').value),
					title: encodeURIComponent(form.querySelector('.title').value),
					bio: encodeURIComponent(form.querySelector('.bio').value),
					head_shot: form.querySelector('img') ? form.querySelector('img').getAttribute('data-src') : ''
				}
			} else {
				return item
			}
		})

		this.setState({
			items: items,
			readyToSave: true,
			message: ''
		})
	}

	handleSaveChanges(){
		// Create the data to store.
		var data = {
			items: this.state.items,
		}

		// Save the items to the API.
		axios({
			method: 'POST',
			url: 'https://dhsetheatre-api.madebypeppernet.com//api-admin.php',
			headers: { 'Content-type': 'application/x-www-form-urlencoded' },
			data: {
				filename: 'staff',
				content: JSON.stringify(data)
			}
		}).then( (response) => {
			this.setState({
				readyToSave: false,
				changedSaved: true,
				message: 'Preview Saved'
			})
		})
	}

	handleSubmit(e){
		// Kill default functionality.
		e.preventDefault()
		return false
	}

	render() {
		return (
			<section className="container edit">
				<h2>Staff</h2>
				{ this.state.readyToSave ?
						<button className="save button" onClick={this.handleSaveChanges.bind(this)}>Save Preview</button> :
						null
				}
				{
					this.state.message.length ?
						<p className="message">{this.state.message}</p> :
						null
				}
				<List
					items={this.state.items}
					remove={this.handleItemRemove.bind(this)}
					update={this.handleItemUpdate.bind(this)}
					submit={this.handleSubmit.bind(this)}
					handleImageUploadComplete={this.handleImageUploadComplete.bind(this)}
				/>
				<button className="add button" onClick={this.handleAddNewItem.bind(this)}>Add New Staff Member</button>
			</section>
		)
	}
}

export default Staff



// WEBPACK FOOTER //
// ./src/pages/staff.js